export const STATUSE_CODES = {
  OPEN: 'OPEN',
  PARTIALLY_OPEN: 'PARTIALLY_OPEN',
  CLOSED: 'CLOSED'
};

export const PAYMENT_METHODS = [
  '1099VISIT',
  'W2VISIT',
  'W2SALARY',
  'W2VISITHOURLY',
  'EXTERNALPROVIDERGROUP'
];

export const NEW_PATIENT_STATUSES = {
  ACCEPT: 'ACCEPT',
  OFF_BY_PROVIDER: 'OFF_BY_PROVIDER',
  OFF_BY_ADMIN: 'OFF_BY_ADMIN',
  NO_ACTIVE_LICENSES: 'NO_ACTIVE_LICENSES'
};
